import React from 'react';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import 'assets/scss/components/banners.css';
import { isReportLimited, getPlanLimitDetails } from '../../utils/plansHelper';
import { getUserData } from '../../constants/localStorageManager';

const UpgradeToPro = () => {
  if (isReportLimited()) {
    const userData = getUserData() || {};
    const planLimitData = getPlanLimitDetails();
    const participantsLimit = planLimitData.SURVEY_PARTICIPANTS;
    const { survey_participant_count } = userData;
    const hasReachedLimit = survey_participant_count >= participantsLimit;
    if (hasReachedLimit) {
      return (
        <div className="plain-banner w-100">
          <div className="container">
            <div className="row d-flex justify-content-center">
              <p className="d-inline">
                <FontAwesomeIcon icon="info-circle" />
                This report is limited to the first {participantsLimit} survey
                participants. Unlock unlimited reporting when you.
              </p>{' '}
              <Link to="/renew/select-plan" target="_blank">
                Upgrade plan.
              </Link>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }

  return null;
};

export default UpgradeToPro;



// WEBPACK FOOTER //
// ./src/components/Banners/reportLimitBanner.js